module.exports = __webpack_public_path__ + "static/page-2-29418d11cdf62d47adbcb5501d66d7d6.jpg";